import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPythonDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 58,
	height: 59,
	viewBox: "0 0 58 59",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M28.7336 5.26405C16.5956 5.26405 17.3531 10.5967 17.3531 10.5967L17.3681 16.1215H28.9502V17.779H12.7648C12.7648 17.779 5 16.8859 5 29.2949C5 41.7009 11.7787 41.2619 11.7787 41.2619H15.8247V35.5039C15.8247 35.5039 15.6065 28.6365 22.4958 28.6365H33.9823C33.9823 28.6365 40.4368 28.7424 40.4368 22.3169V11.6926C40.4368 11.6926 41.4169 5.26405 28.7336 5.26405ZM22.3464 8.97857C23.4983 8.97857 24.4306 9.9231 24.4306 11.0901C24.4306 12.2572 23.4983 13.2017 22.3464 13.2017C22.0725 13.2021 21.8013 13.1477 21.5483 13.0418C21.2952 12.9358 21.0653 12.7803 20.8717 12.5841C20.6781 12.388 20.5246 12.155 20.42 11.8987C20.3153 11.6423 20.2617 11.3675 20.2621 11.0901C20.2621 9.9231 21.1944 8.97857 22.3464 8.97857Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.2666 53.2637C41.4046 53.2637 40.6471 47.9309 40.6471 47.9309L40.6322 42.4058H29.05V40.7483H45.2339C45.2339 40.7483 53.0002 41.6414 53.0002 29.2334C53.0002 16.8254 46.2215 17.2659 46.2215 17.2659H42.1756V23.0226C42.1756 23.0226 42.3937 29.8904 35.5045 29.8904H24.0179C24.0179 29.8904 17.5635 29.7844 17.5635 36.2102V46.835C17.5635 46.835 16.5833 53.2637 29.2666 53.2637ZM35.6539 49.5491C35.38 49.5495 35.1088 49.4951 34.8558 49.3891C34.6027 49.2832 34.3728 49.1276 34.1792 48.9315C33.9856 48.7353 33.8321 48.5024 33.7275 48.246C33.6229 47.9896 33.5692 47.7148 33.5696 47.4374C33.5696 46.2719 34.5019 45.3273 35.6539 45.3273C36.8058 45.3273 37.7381 46.2704 37.7381 47.4374C37.7381 48.606 36.8058 49.5491 35.6539 49.5491Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgPythonDark);
export { ForwardRef as ReactComponent };
